<template>
    <!-- Wallet Card -->
    <div class="button-grid-container" v-if="unit.election_enabled">
        <div class="button-grid">

            <!-- <router-link :to="'/org/1/' + unit.id + '/qvp-kids-exam-center-list'"
                class="modern-button org-action-btn" v-if="user_level == 1 && currentUser && currentUser.wing == 3">
                <div class="icon-circle">
                    <ion-icon name="list-outline"></ion-icon>
                </div>
                <span class="button-text">QVP Kids കേന്ദ്രങ്ങൾ</span>
            </router-link> -->
            <!-- <router-link :to="'/org/2/' + unit.id + '/qvp-kids-exam-center-list'"
                class="modern-button org-action-btn" v-if="user_level == 2 && currentUser && currentUser.wing == 3">
                <div class="icon-circle">
                    <ion-icon name="list-outline"></ion-icon>
                </div>
                <span class="button-text">QVP Kids കേന്ദ്രങ്ങൾ</span>
            </router-link> -->

            <router-link :to="'/org/4/' + unit.id + '/members-list'"
                class="modern-button org-action-btn" v-if="user_level == 4 && unit.member_list_enabled">
                <div class="icon-circle">
                    <ion-icon name="people-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('members_list')}}</span>
            </router-link>

            <router-link :to="'/org/4/' + unit.id + '/members-directory'"
                class="modern-button org-action-btn" v-if="user_level == 4 && unit.draft_list_enabled">
                <div class="icon-circle">
                    <ion-icon name="list-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('draft_list')}}</span>
            </router-link>

            <router-link :to="'/org/4/' + unit.id + '/dawa-directory'"
                class="modern-button org-action-btn" v-if="user_level == 4 && unit.dawa_directory_enabled">
                <div class="icon-circle">
                    <ion-icon name="book-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('dawa_directory')}}</span>
            </router-link>

            <router-link :to="'/org/4/' + unit.id + '/clustors-list'"
                class="modern-button org-action-btn" v-if="user_level == 4 && unit.unit_cluster_enabled">
                <div class="icon-circle">
                    <ion-icon name="grid-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('unit_clusters')}}</span>
            </router-link>

            <router-link :to="'/org/2/' + unit.id + '/clustors-list-dist'"
                class="modern-button org-action-btn" v-if="user_level == 2 && unit.district_cluster_enabled">
                <div class="icon-circle">
                    <ion-icon name="grid-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('district_cluster_mapping')}}</span>
            </router-link>

            <router-link :to="'/org/4/' + unit.id + '/data-collection'"
                class="modern-button org-action-btn" v-if="user_level == 4 && unit.unit_data_enabled">
                <div class="icon-circle">
                    <ion-icon name="clipboard-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('unit_data_collection')}}</span>
            </router-link>

            <router-link :to="'/org/' + user_level + '/' + unit.id + '/org-excecutive-list'"
                class="modern-button org-action-btn" v-if="unit.executive_enabled">
                <div class="icon-circle">
                    <ion-icon name="people-circle-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('executives')}}</span>
            </router-link>

            <router-link :to="'/org/' + (user_level) + '/' + unit.id + '/general-body-council'"
                class="modern-button org-action-btn" v-if="unit.district_general_council_enabled">
                <div class="icon-circle">
                    <ion-icon name="people-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('district_general_body_council')}}</span>
            </router-link>

            <router-link to="/org/1/1/general-body-council"
                class="modern-button org-action-btn" v-if="user_level == 1">
                <div class="icon-circle">
                    <ion-icon name="people-outline"></ion-icon>
                </div>
                <span class="button-text">{{ $t('state_general_council') }}</span>
            </router-link>

            <router-link to="/org/1/1/council-members"
                class="modern-button org-action-btn" v-if="user_level == 1">
                <div class="icon-circle">
                    <ion-icon name="people-circle-outline"></ion-icon>
                </div>
                <span class="button-text">{{ $t('council_members') }}</span>
            </router-link>

            <router-link :to="'/org/' + (user_level) + '/' + unit.id + '/womens-council'"
                class="modern-button org-action-btn" v-if="unit.district_women_council_enabled">
                <div class="icon-circle">
                    <ion-icon name="ribbon-outline"></ion-icon>
                </div>
                <span class="button-text">{{ $t('district_womens_council') }}</span>
            </router-link>

            <router-link :to="'/org/' + (user_level) + '/' + unit.id + '/girls-council'"
                class="modern-button org-action-btn" v-if="unit.district_girls_council_enabled">
                <div class="icon-circle">
                    <ion-icon name="flower-outline"></ion-icon>
                </div>
                <span class="button-text">{{ $t('district_girls_council') }}</span>
            </router-link>

            <router-link :to="'/org/' + user_level + '/' + unit.id + '/district-zone-executive-list'"
                class="modern-button org-action-btn" v-if="(user_level == 2 || user_level == 3) && unit.executive_enabled">
                <div class="icon-circle">
                    <ion-icon name="business-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('unit_level_executives')}}</span>
            </router-link>

            <router-link :to="'/org/' + user_level + '/' + (unit && unit.id != null && unit.id !== '' ? unit.id : 0) + '/zone-executive-list'"
                class="modern-button org-action-btn" v-if="user_level == 1 || user_level == 2">
                <div class="icon-circle">
                    <ion-icon name="person-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('zone_level_executives')}}</span>
            </router-link>

            <router-link :to="'/org/' + user_level + '/' + unit.id + '/district-executive-list'"
                class="modern-button org-action-btn" v-if="user_level == 1">
                <div class="icon-circle">
                    <ion-icon name="star-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('district_level_executives')}}</span>
            </router-link>

            <!-- <router-link :to="'/org/' + user_level + '/' + unit.id + '/election-officers'"
                class="modern-button org-action-btn" v-if="unit.election_officer_enabled">
                <div class="icon-circle">
                    <ion-icon name="person-circle-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('election_officers')}}</span>
            </router-link> -->

            <router-link :to="'/org/' + (user_level) + '/' + currentUser.unit_id + '/cons-report'"
                class="modern-button org-action-btn" v-if="user_level == 4 && unit.membership_report_enabled">
                <div class="icon-circle">
                    <ion-icon name="document-text-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('membership_report')}}</span>
            </router-link>

            <router-link :to="'/org/' + (user_level) + '/' + currentUser.zone_id + '/zone-cons-report'"
                class="modern-button org-action-btn" v-if="user_level == 3 && unit.membership_report_enabled">
                <div class="icon-circle">
                    <ion-icon name="document-text-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('unit_membership_report_election')}}</span>
            </router-link>

            <router-link
                v-if="currentUser && parseInt(currentUser.user_level, 10) === 3 && (currentUser.zone_id || user_level_id || (unit && unit.id)) && !isQhlsWingUser"
                :to="'/org/3/' + (currentUser.zone_id || user_level_id || (unit && unit.id) || '') + '/qvp-kids-exam-center'"
                class="modern-button org-action-btn"
            >
                <div class="icon-circle">
                    <ion-icon name="school-outline"></ion-icon>
                </div>
                <span class="button-text">QVP Kids പരീക്ഷാ കേന്ദ്രം</span>
            </router-link>

            <router-link :to="'/org/' + (user_level) + '/' + unit.id + '/org-councilers-list'"
                class="modern-button org-action-btn" v-if="unit.state_district_concillers_enabled">
                <div class="icon-circle">
                    <ion-icon name="people"></ion-icon>
                </div>
                <span class="button-text">{{ $t('org_councilers_list') }}</span>
            </router-link>

            <!-- Zone Level Council Buttons -->
            <router-link :to="'/org/' + (user_level) + '/' + unit.id + '/general-body-council'"
                class="modern-button org-action-btn" v-if="unit.general_council_enabled">
                <div class="icon-circle">
                    <ion-icon name="people-outline"></ion-icon>
                </div>
                <span class="button-text">{{ $t('general_body_council') }}</span>
            </router-link>

            <router-link :to="'/org/' + (user_level) + '/' + unit.id + '/womens-council'"
                class="modern-button org-action-btn" v-if="unit.women_council_enabled">
                <div class="icon-circle">
                    <ion-icon name="ribbon-outline"></ion-icon>
                </div>
                <span class="button-text">{{ $t('womens_council') }}</span>
            </router-link>

            <router-link :to="'/org/' + (user_level) + '/' + unit.id + '/girls-council'"
                class="modern-button org-action-btn" v-if="unit.girls_council_enabled">
                <div class="icon-circle">
                    <ion-icon name="flower-outline"></ion-icon>
                </div>
                <span class="button-text">{{ $t('girls_council') }}</span>
            </router-link>
            
            <router-link :to="'/org/' + (user_level) + '/' + currentUser.unit_id + '/attendance'"
                class="modern-button org-action-btn" v-if="user_level == 4 && unit.election_attendance_enabled">
                <div class="icon-circle">
                    <ion-icon name="checkmark-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('election_attendance')}}</span>
            </router-link>

            

            <router-link :to="'/org/' + user_level + '/' + unit.id + '/reports'"
                class="modern-button org-action-btn" v-if="unit.reports_enabled">
                <div class="icon-circle">
                    <ion-icon name="bar-chart-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('reports')}}</span>
            </router-link>

            <router-link
                :to="'/org/2/' + (currentUser.district_id || user_level_id || unit.id) + '/balavedi-madrasa'"
                class="modern-button org-action-btn"
                v-if="user_level == 2 && unit.balavedi_enabled"
            >
                <div class="icon-circle">
                    <ion-icon name="people-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('balavedi')}}</span>
            </router-link>

            <router-link
                :to="'/org/3/' + (currentUser.zone_id || user_level_id || unit.id) + '/balavedi-madrasa'"
                class="modern-button org-action-btn"
                v-if="user_level == 3"
            >
                <div class="icon-circle">
                    <ion-icon name="people-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('balavedi')}}</span>
            </router-link>

            <router-link :to="'/org/' + (user_level) + '/' + currentUser.district_id + '/election-cons-report'"
                class="modern-button org-action-btn" v-if="user_level == 2 && unit.membership_report_enabled">
                <div class="icon-circle">
                    <ion-icon name="document-text-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('zone_membership_report_election')}}</span>
            </router-link>

            <router-link :to="'/org/' + currentUser.id + '/presiding-units'"
                class="modern-button org-action-btn" v-if="user_level <= 5 && unit.unit_presiding_active">
                <div class="icon-circle">
                        <ion-icon name="list-outline"></ion-icon>
                    </div>
                <span class="button-text">{{$t('presiding_units_btn')}}</span>
            </router-link>

            <!-- <router-link :to="'/org/' + currentUser.id + '/presiding-zones'"
                class="modern-button org-action-btn" v-if="user_level <= 5 && unit.zone_presiding_active">
                <div class="icon-circle">
                        <ion-icon name="list-outline"></ion-icon>
                    </div>
                <span class="button-text">{{$t('presiding_zones_btn')}}</span>
            </router-link> -->

            <router-link :to="'/org/' + currentUser.id + '/presiding-districts'"
                class="modern-button org-action-btn" v-if="user_level <= 5 && unit.district_presiding_active">
                <div class="icon-circle">
                        <ion-icon name="list-outline"></ion-icon>
                    </div>
                <span class="button-text">{{$t('presiding_districts_btn')}}</span>
            </router-link>

            <!-- Circulars Button -->
             <router-link
                :to="'/org/' + user_level + '/' + (unit.zone_id ? unit.zone_id : unit.district_id) + '/circulars'"
                class="modern-button org-action-btn">
                <div class="icon-circle">
                    <ion-icon name="mail-unread-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('circulars')}}</span>
            </router-link>

            <router-link :to="'/org/' + (user_level) + '/' + (user_level == 1 ? 0 : unit.id) + '/election-cons-report'"
                class="modern-button org-action-btn" v-if="user_level == 1 && unit.membership_report_enabled">
                <div class="icon-circle">
                    <ion-icon name="document-text-outline"></ion-icon>
                </div>
                <span class="button-text">{{$t('district_membership_report_election')}}</span>
            </router-link>

            <!-- Backend-provided extra buttons (append at bottom of grid); hide relief links duplicated in bottom section -->
            <router-link
                v-for="extra_link in extraLinksForGrid"
                :key="extra_link.url || extra_link.btn_text"
                :to="extra_link.url"
                class="modern-button org-action-btn"
            >
                <div class="icon-circle">
                    <ion-icon :name="extra_link.icon || 'link-outline'"></ion-icon>
                </div>
                <span class="button-text" :class="extra_link.class">{{ extra_link.btn_text }}</span>
            </router-link>
            
        </div>
    </div>
    <div class="section">
        <div class="wallet-card" v-if="permissions.youth_video">
            <div class="listed-detail mt-0 page-title">
                <h3 class="text-center mal-text mt-1 custom-title">{{ responseData.video.title }}</h3>
            </div>
            <iframe class="mt-1" width="100%" height="250" :src="responseData.video.link"
                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" controls='0'
                allowfullscreen></iframe>
        </div>
    </div>
    <div class="section mt-1" v-if="(permissions.common_links && responseData.common_links.length) || (currentUser && currentUser.user_level <= 4) || isVoOfficer">
        <div class="transactions">
            <!-- <router-link
                v-if="currentUser && currentUser.user_level <= 4"
                :to="'/org/' + user_level + '/' + user_level_id + '/qvp-kids-list'"
                class="item"
            >
                <div class="detail">
                    <div class="image-block imaged w48 qvp-kids-icon">
                        <ion-icon name="school-outline"></ion-icon>
                    </div>
                    <div>
                        <strong class="mal-text">QVP Kids</strong>
                        <p class="mal-text">കിഡ്സ് രജിസ്ട്രേഷൻ ലിസ്റ്റ്</p>
                    </div>
                </div>
                <div class="right">
                    <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
                </div>
            </router-link> -->

            <template v-for="(common_link, linkIndex) in responseData.common_links" :key="'org-cl-' + linkIndex">
                <a
                    v-if="common_link.group"
                    href="javascript:void(0)"
                    class="item"
                    @click="openCommonLinkGroup(common_link)"
                >
                    <div class="detail">
                        <div v-if="common_link.icon" class="image-block imaged w48 qvp-kids-icon">
                            <ion-icon :name="common_link.icon"></ion-icon>
                        </div>
                        <img v-else :src="common_link.image" alt="img" class="image-block imaged w48">
                        <div>
                            <strong class="mal-text">{{ common_link.title }}</strong>
                            <p class="mal-text">{{ common_link.desc }}</p>
                        </div>
                    </div>
                    <div class="right">
                        <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
                    </div>
                </a>
                <a
                    v-else
                    :href="resolveQhlsDashboardLink(common_link.link)"
                    class="item"
                >
                    <div class="detail">
                        <div v-if="common_link.icon" class="image-block imaged w48 qvp-kids-icon">
                            <ion-icon :name="common_link.icon"></ion-icon>
                        </div>
                        <img v-else :src="common_link.image" alt="img" class="image-block imaged w48">
                        <div>
                            <strong class="mal-text">{{ common_link.title }}</strong>
                            <p class="mal-text">{{ common_link.desc }}</p>
                        </div>
                    </div>
                    <div class="right">
                        <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
                    </div>
                </a>
            </template>
        </div>
    </div>

    <Transition name="org-link-sheet" @after-leave="onCommonLinkGroupAfterLeave">
        <div
            v-if="activeCommonLinkGroup"
            class="native-modal-overlay org-link-group-modal"
            @click="closeCommonLinkGroup"
        >
            <div class="native-modal-content org-link-sheet-panel" @click.stop>
                <div class="native-modal-header">
                    <h5 class="mal-text">{{ activeCommonLinkGroup.title }}</h5>
                    <button class="org-sheet-close" @click="closeCommonLinkGroup">
                        <ion-icon name="close-outline"></ion-icon>
                    </button>
                </div>
                <div class="native-modal-body org-group-sheet">
                    <div class="org-group-btn-list">
                        <a
                            v-for="(sub, idx) in activeCommonLinkGroup.items"
                            :key="'qhls-cl-' + idx"
                            :href="resolveQhlsDashboardLink(sub.link)"
                            class="org-group-btn"
                            @click="closeCommonLinkGroup"
                        >
                            <div class="org-group-btn-icon">
                                <ion-icon name="school-outline"></ion-icon>
                            </div>
                            <span class="org-group-btn-text mal-text">{{ sub.title }}</span>
                            <ion-icon name="chevron-forward-outline" class="org-group-btn-arrow"></ion-icon>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
    <div
        v-if="((currentUser.user_level <= 4 && permissions.user ? permissions.user.user_level <= 4 : false) && !loading)">
        <div class="listview-title mt-2" v-if="user_level != 4">{{ sub_level_list_name }}
        </div>
        <div class="section text-center" v-if="loading && user_level != 4">
            <div class="spinner-border text-secondary" role="status"></div>
        </div>
        <ul class="listview image-listview inset text" v-if="user_level != 4">
            <li v-for="sub_level in sub_levels" v-bind:key="sub_level.id">
                <a href="javascript:void(0)" class="item">
                    <!-- <img src="assets/img/sample/avatar/avatar1.jpg" alt="image" class="image"> -->
                    <div class="in">
                        <router-link :to="'org/' + (user_level + 1) + '/' + sub_level.id">
                            <div>
                                <!-- <header>User</header> -->
                                <b class="list-title">{{ sub_level.name }}</b>
                                <!-- <footer>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="chip chip-media">
                                                <i class="chip-icon bg-primary">WS</i>
                                                <span class="chip-label">{{ sub_level.wisdom_count_filled }}/{{
                                                        sub_level.wisdom_count
                                                }}</span>
                                            </div>
                                            <div class="chip chip-media">
                                                <i class="chip-icon bg-success">YT</i>
                                                <span class="chip-label">{{ sub_level.youth_count_filled }}/{{
                                                        sub_level.youth_count
                                                }}</span>
                                            </div>

                                        </div>
                                        <div class="col-12 mt-1">
                                            <div class="chip chip-media">
                                                <i class="chip-icon bg-danger">ST</i>
                                                <span class="chip-label">{{ sub_level.students_count_filled }}/{{
                                                        sub_level.students_count
                                                }}</span>
                                            </div>
                                            <div class="chip chip-media">
                                                <i class="chip-icon bg-pink">WM</i>
                                                <span class="chip-label">{{ sub_level.women_count_filled }}/{{
                                                        sub_level.women_count
                                                }}</span>
                                            </div>

                                        </div>
                                        <div class="col-12 mt-1">
                                            <div class="chip chip-media">
                                                <i class="chip-icon bg-pink-dark">GL</i>
                                                <span class="chip-label">{{ sub_level.girls_count_filled }}/{{
                                                        sub_level.girls_count
                                                }}</span>
                                            </div>
                                            <div class="chip chip-media">
                                                <i class="chip-icon bg-warning">BL</i>
                                                <span class="chip-label">{{ sub_level.balavedi_count_filled }}/{{
                                                        sub_level.balavedi_count
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="chip chip-media mt-1">
                                        <i class="chip-icon bg-secondary">Total</i>
                                        <span class="chip-label">{{ sub_level.members_count_filled }}/{{
                                                sub_level.members_count
                                        }}</span>
                                    </div>
                                </footer> -->
                            </div>
                        </router-link>
                        <div class="card-button dropdown">
                            <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                                :data-bs-target="'#actionSheetInset' + sub_level.id">
                                <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                            </button>
                        </div>
                        <div class="modal fade action-sheet" :id="'actionSheetInset' + sub_level.id" tabindex="-1"
                            role="dialog">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Action</h5>
                                    </div>
                                    <div class="modal-body">
                                        <ul class="action-button-list">
                                            <li v-if="currentUser.user_level <= 3">
                                                <a href="javascript:void(0)" class="btn btn-list"
                                                    data-bs-dismiss="modal" @click="nerpathamTarget(sub_level)">
                                                    <span>
                                                        <ion-icon name="book-outline"></ion-icon>നേർപഥം ടാർഗറ്റ്
                                                    </span>
                                                </a>
                                            </li>
                                            <li class="action-divider"></li>
                                            <li>
                                                <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                    <span>
                                                        <ion-icon name="close-outline"></ion-icon> Cancel
                                                    </span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <span class="text-muted">View</span> -->
                    </div>
                </a>
            </li>
        </ul>
        <add-members ref="add_member" v-if="permissions.members ? permissions.members.view : false"
            v-bind:current_user="currentUser" v-bind:permissions="permissions"></add-members>
    </div>

    <div class="section mt-1" v-if="(currentUser.user_level == 5 && !loading)">
        <div class="card">
            <div class="card-body pt-0 pb-0 text-center">
                <img src="assets/logo.png" alt="image" class="imaged w-50 ">
                <h2 class="mt-0 mal-text">{{ sub_level.name_mal }} ശാഖ</h2>
            </div>
        </div>
        <div class="wallet-card  mt-1">
            <div class="wallet-footer row">
                <div class="item col-12" v-if="permissions.view_events">
                    <router-link :to="'/event-list'">
                        <a href="javascript:void(0)">
                            <div class="icon-wrapper back-color-primary">
                                <ion-icon name="mic-outline"></ion-icon>
                                <strong class="menu-title">Events</strong>
                            </div>
                        </a>
                    </router-link>
                </div>
                <div class="item col-12" v-if="permissions.nerpatham ? permissions.nerpatham.view : false">
                    <router-link
                        :to="'/org/' + (currentUser.user_level - 1) + '/' + currentUser.unit_id + '/nerpatham-list'">
                        <a href="javascript:void(0)">
                            <div class="icon-wrapper back-color-blue1">
                                <ion-icon name="book-outline"></ion-icon>
                                <strong class="menu-title mal-text">നേർപഥം ചേർക്കാനും ചേർത്തവരെ കാണാനും ഇവിടെ
                                    അമർത്തുക</strong>
                            </div>
                        </a>
                    </router-link>
                </div>
                <!-- <div class="item col-12" v-if="permissions.peroface_confirmation ? permissions.peroface_confirmation : false">
                        <router-link :to="'/proface-confirmation'">
                            <a href="javascript:void(0)">
                                <div class="icon-wrapper back-color-blue1">
                                    <ion-icon name="checkmark-done-outline"></ion-icon>
                                    <strong class="menu-title">Proface Confirmation</strong>
                                </div>
                            </a>
                        </router-link>
                    </div> -->
                <div class="item col-12"
                    v-if="permissions.unit_election ? permissions.unit_election.presiding_officer : false">
                    <router-link :to="'/org/' + currentUser.id + '/presiding-units'">
                        <a href="javascript:void(0)">
                            <div class="icon-wrapper back-color-primary">
                                <ion-icon name="list-outline"></ion-icon>
                                <strong class="menu-title mal-text">താങ്കൾ പ്രെസീഡിങ് ഓഫീസർ ആയ ശാഖകൾ ലഭിക്കാൻ ഇവിടെ
                                    അമർത്തുക</strong>
                            </div>
                        </a>
                    </router-link>
                </div>
                <div class="item col-12"
                    v-if="permissions.zone_election ? permissions.zone_election.presiding_officer : false">
                    <router-link :to="'/org/' + currentUser.id + '/presiding-zones'">
                        <a href="javascript:void(0)">
                            <div class="icon-wrapper back-color-primary">
                                <ion-icon name="list-outline"></ion-icon>
                                <strong class="menu-title mal-text">താങ്കൾ പ്രെസീഡിങ് ഓഫീസർ ആയ മണ്ഡലങ്ങൾ ലഭിക്കാൻ ഇവിടെ
                                    അമർത്തുക</strong>
                            </div>
                        </a>
                    </router-link>
                </div>
                <div class="item col-12"
                    v-if="permissions.district_election ? permissions.district_election.presiding_officer : false">
                    <router-link :to="'/org/' + currentUser.id + '/presiding-districts'">
                        <a href="javascript:void(0)">
                            <div class="icon-wrapper back-color-primary">
                                <ion-icon name="receipt-outline"></ion-icon>
                                <strong class="menu-title mal-text">താങ്കൾ പ്രെസീഡിങ് ഓഫീസർ ആയ ജില്ലകൾ ലഭിക്കാൻ
                                    ഇവിടെ
                                    അമർത്തുക</strong>
                            </div>
                        </a>
                    </router-link>
                </div>
            </div>
        </div>
        <!-- extra_links moved into the main ORG button grid above -->
        <div class="wallet-card  mt-1" v-if="permissions.peroface">
            <div class="wallet-footer row">
                <div class="item col-6"
                    v-if="permissions.peroface_confirmation ? permissions.peroface_confirmation : false">
                    <router-link :to="'/proface-confirmation'">
                        <a href="javascript:void(0)">
                            <div class="icon-wrapper back-color-blue1">
                                <ion-icon name="checkmark-done-outline"></ion-icon>
                                <strong class="menu-title">Proface Confirmation</strong>
                            </div>
                        </a>
                    </router-link>
                </div>
                <div class="item col-6"
                    v-if="permissions.peroface_get_delegate ? permissions.peroface_get_delegate : false">
                    <router-link :to="'/proface-get'">
                        <a href="javascript:void(0)">
                            <div class="icon-wrapper back-color-blue1">
                                <ion-icon name="search-outline"></ion-icon>
                                <strong class="menu-title">Proface Get Delegate</strong>
                            </div>
                        </a>
                    </router-link>
                </div>
                <div class="item col-6" v-if="permissions.peroface_parking ? permissions.peroface_parking : false">
                    <router-link
                        :to="'/event/' + user_level + '/' + this.user_level_id + '/parking-cordinator/proface'">
                        <a href="javascript:void(0)">
                            <div class="icon-wrapper back-color-blue1">
                                <ion-icon name="car-outline"></ion-icon>
                                <strong class="menu-title">Proface Parking</strong>
                            </div>
                        </a>
                    </router-link>
                </div>
            </div>
        </div>
        <!-- <div class="card mt-1">
            <div class="card-body pt-0 pb-0 text-center">
                <h2 class="mt-0 mal-text">ബയോഡാറ്റ പൂരിപ്പിക്കുമ്പോൾ ശ്രദ്ധിക്കേണ്ട കാര്യങ്ങൾ.</h2>
            </div>
            <ul class="listview image-listview text">
                <li>
                    <a class="item">
                        <div class="in">
                            <div>1. പേരും അഡ്രസ്സും ഇംഗ്ലീഷിൽ തന്നെ ടൈപ്പ് ചെയ്യുവാൻ ശ്രദ്ധിക്കണം.</div>
                        </div>
                    </a>
                </li>
                <li>
                    <a class="item">
                        <div class="in">
                            <div>2. ഫോൺ നമ്പറും whatsapp നമ്പറും ചേർക്കുമ്പോൾ രാജ്യത്തിന്റെ ശരിയായ കോഡ്
                                തിരഞ്ഞെടുക്കാൻ മറക്കരുത്.</div>
                        </div>
                    </a>
                </li>
                <li>
                    <a class="item">
                        <div class="in">
                            <div>3. ശരിയായ രക്തഗ്രൂപ്പ് ലിസ്റ്റിൽ നിന്നും തിരഞ്ഞെടുക്കണം. അറിയില്ലെങ്കിൽ "Not known"
                                എന്ന ഓപ്ഷൻ തിരഞ്ഞെടുക്കണം. തെറ്റായ രക്തഗ്രൂപ്പ് ഒരിക്കലും തിരഞ്ഞെടുക്കരുത്.</div>
                        </div>
                    </a>
                </li>
                <li>
                    <a class="item">
                        <div class="in">
                            <div>4. സ്ഥിരം മേൽവിലാസവും ഇപ്പോഴത്തെ മേൽവിലാസവും ഒന്നുതന്നെയാണെങ്കിൽ ആദ്യത്തേത്
                                പൂരിപ്പിച്ച ശേഷം "ഇപ്പോഴത്തെ അഡ്രസ്സും സ്ഥിരം അഡ്രസ്സും ഒന്നുതന്നെയാണ് " എന്ന ഓപ്ഷൻ
                                സെലക്ട് ചെയ്താൽ മതിയാകുന്നതാണ്.</div>
                        </div>
                    </a>
                </li>
                <li>
                    <a class="item">
                        <div class="in">
                            <div>5. ഓരോ പേജിലെയും വിവരങ്ങൾ കൃത്യമായി പൂരിപ്പിച്ച ശേഷം താഴെ ഉള്ള "Save & Next"
                                ക്ലിക്ക് ചെയ്ത് അടുത്ത പേജിലേക്ക് പോകാവുന്നതാണ്.</div>
                        </div>
                    </a>
                </li>
                <li>
                    <a href="#" class="item">
                        <div class="in">
                            <div>6. പൂരിപ്പിക്കുന്ന വ്യക്തിക്ക് ഏറ്റവും അനുയോജ്യമായ വിദ്യാഭ്യാസ യോഗ്യത ലിസ്റ്റിൽ
                                ലഭ്യമല്ലെങ്കിൽ "other qualifications" എന്നത് തിരഞ്ഞെടുക്കണം.</div>
                        </div>
                    </a>
                </li>

            </ul>
        </div> -->
    </div>

    <!-- * AddAdminModel -->
    <div class="modal fade action-sheet" id="nerpathamTargetModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Nerpatham Target</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="addNerpathamTarget">
                            <div class="form-group basic">
                                <label class="label" for="Target">Target</label>
                                <Field name="target" type="number" class="form-control" id="target"
                                    v-model="nerpatham_target" placeholder="Enter Target" />
                                <input type="hidden" v-model="sub_level_id">
                                <div class="form-group" v-if="message">
                                    <div v-if="message" class="error-feedback">
                                        {{ message }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading">
                                    <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                    <span>Save</span></button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="org-bottom-spacer"></div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>
<script>
import { Form, Field } from "vee-validate";
import UserService from "../services/user.service";
import { fetchRoleContext } from "../services/roleContext.service";
import { scopeQhlsDashboardLink } from "../utils/orgLinks";
import { qhlsInvigilatorCenterRoute } from "../utils/qhlsInvigilator";
// import AddMembers from './MembersList.vue';
import AlertModel from "./layouts/AlertModel.vue";
import DialogModel from "./layouts/DialogModel.vue";
import $ from 'jquery';
export default {
    name: 'Organization',
    components: {
        Form,
        Field,
        // AddMembers,
        AlertModel,
        DialogModel
    },
    data() {
        return {
            loading: false,
            message: "",
            user_level: "",
            permissions: [],
            sub_levels: [],
            sub_level_list_name: "",
            user_level_id: "",
            unit: [],
            nerpatham_target: '',
            sub_level_id: '',
            alert_type: '',
            alert_message: '',
            editable: true,
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            sub_level: [],
            responseData: {
                video: [],
                common_links: []
            },
            invigilatorCenters: [],
            activeCommonLinkGroup: null,
            isVoOfficer: false,
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isQhlsWingUser() {
            const cu = this.currentUser;
            if (!cu) return false;
            const w = cu.wing_id ?? cu.wing ?? cu.wing_type;
            if (w == null || w === '') return true;
            const n = parseInt(String(w), 10);
            return n === 1 || n === 2 || n === 3;
        },
        showQhlsInvigilatorButton() {
            return (this.invigilatorCenters || []).length > 0;
        },
        qhlsInvigilatorCenterLink() {
            return qhlsInvigilatorCenterRoute(this.invigilatorCenters, this.currentUser) || "/org";
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = this.currentUser.user_level;
            if (this.user_level == 1) {
                this.sub_level_list_name = 'District List';
                this.user_level_id = 0;
                this.$root.updateParent("Loading...");
            } else if (this.user_level == 2) {
                this.sub_level_list_name = 'Zone List';
                this.user_level_id = this.currentUser.district_id;
                this.$root.updateParent("Loading...");
            }
            else if (this.user_level == 3) {
                this.sub_level_list_name = 'Unit List';
                this.user_level_id = this.currentUser.zone_id;
                this.$root.updateParent("Loading...");
            }
            else if (this.user_level == 4) {
                this.sub_level_list_name = 'Members List';
                this.user_level_id = this.currentUser.unit_id;
                this.$root.updateParent("Loading...");
            }
            this.getSubLevels();
        }
    },
    methods: {
        resolveQhlsDashboardLink(link) {
            return scopeQhlsDashboardLink(link, this.$route);
        },
        openCommonLinkGroup(group) {
            this.activeCommonLinkGroup = group;
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
        },
        closeCommonLinkGroup() {
            this.activeCommonLinkGroup = null;
        },
        onCommonLinkGroupAfterLeave() {
            document.body.style.position = '';
            document.body.style.width = '';
        },
        // Combines what used to be 4 separate role-check round trips (VO, Dawa Fund followup,
        // Fund incharge, QHLS invigilator) into one request — each fired unconditionally on
        // every ORG page load even though most users have none of these roles. Cached per
        // session via fetchRoleContext — role status rarely changes, no need to refetch every
        // Org visit.
        loadRoleContextAndMerge() {
            fetchRoleContext('get-org-role-context').then((data) => {
                if (!data) return;

                if (data.is_vo) {
                    this.isVoOfficer = true;
                    const hashLink = '/#/sneha-sparsham-verification';
                    const links = this.responseData.common_links || [];
                    if (!links.some((l) => l.link === hashLink)) {
                        links.splice(2, 0, {
                            link: hashLink,
                            title: 'സ്നേഹ സ്പർശം - Verification',
                            desc: 'സ്നേഹ സ്പർശം അപേക്ഷകൾ പരിശോധിക്കാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക.',
                            image: 'https://guide.msoftit.com/uploads/image/1692694447.jpeg',
                        }); // place after the first 2 entries, not at the very top
                    }
                    this.responseData.common_links = links;
                }

                if (data.dawa_fund_followup_districts && data.dawa_fund_followup_districts.length) {
                    const links = this.responseData.common_links || [];
                    let insertAt = 3; // place after the first 3 entries, not at the very bottom
                    data.dawa_fund_followup_districts.forEach((d) => {
                        const hashLink = '/#/org/2/' + d.id + '/fund-collection-report/' + data.fund_type_id;
                        if (!links.some((l) => l.link === hashLink)) {
                            links.splice(insertAt, 0, {
                                link: hashLink,
                                title: 'Youth Dawa Fund ' + d.name,
                                desc: 'നിങ്ങൾക്ക് ഫോളോഅപ്പ് ചുമതലയുള്ള ജില്ലയുടെ Youth Dawa Fund റിപ്പോർട്ട്.',
                                image: 'https://guide.msoftit.com/uploads/image/1782049733.jpeg',
                            });
                            insertAt += 1;
                        }
                    });
                    this.responseData.common_links = links;
                }

                if (data.fund_incharge_list && data.fund_incharge_list.length) {
                    const links = this.responseData.common_links || [];
                    let insertAt = 3; // place after the first 3 entries, not at the very bottom
                    data.fund_incharge_list.forEach((row) => {
                        const hashLink = '/#/org/' + row.user_level + '/' + row.id + '/fund-collection-report/' + data.fund_type_id;
                        if (!links.some((l) => l.link === hashLink)) {
                            links.splice(insertAt, 0, {
                                link: hashLink,
                                title: 'Youth Dawa Fund ' + row.name,
                                desc: 'നിങ്ങൾ ഇൻചാർജ് ആയ Youth Dawa Fund റിപ്പോർട്ട്.',
                                image: 'https://guide.msoftit.com/uploads/image/1782049733.jpeg',
                            });
                            insertAt += 1;
                        }
                    });
                    this.responseData.common_links = links;
                }

                if (data.invigilator_unit_ids && data.invigilator_unit_ids.length) {
                    this.invigilatorCenters = data.invigilator_unit_ids.map((unitId) => ({ unit_id: unitId }));
                    this.mergeInvigilatorIntoQhlsCommonLinks();
                }
            }).catch(() => {});
        },
        mergeInvigilatorIntoQhlsCommonLinks() {
            if (!this.showQhlsInvigilatorButton) {
                return;
            }
            const hashLink = '/#' + this.qhlsInvigilatorCenterLink;
            const entry = {
                link: hashLink,
                title: 'QHLS പരീക്ഷാ കേന്ദ്രം',
                desc: 'QHLS പരീക്ഷാ കേന്ദ്രം കാണാനും നിയന്ത്രിക്കാനും ഇവിടെ ക്ലിക്ക് ചെയ്യുക.',
                image: 'https://guide.msoftit.com/uploads/image/1744472179.png',
            };
            const links = this.responseData.common_links || [];
            const groupIdx = links.findIndex((l) => l.group && l.group_key === 'qhls_exam');
            if (groupIdx >= 0) {
                const items = links[groupIdx].items || [];
                if (!items.some((i) => i.link === hashLink)) {
                    items.push(entry);
                    links[groupIdx].items = items;
                }
                return;
            }
            if (!links.some((l) => l.link === hashLink)) {
                links.push(entry);
            }
            this.responseData.common_links = links;
        },
        isReliefExtraLink(link) {
            const url = String(link.url || '').toLowerCase();
            const text = String(link.btn_text || '');
            if (url.includes('relief')) return true;
            if (/relief/i.test(text) || text.includes('റിലീഫ്')) return true;
            return false;
        },
        openAddMemberModel() {
            this.$refs.add_member.adminAdd();
        },

        getSubLevels() {
            this.loading = true;
            if (this.user_level == 2) {
                this.currentUser.district_id;
            } else if (this.user_level == 3) {
                this.currentUser.zone_id;
            } else if (this.user_level == 4) {
                this.currentUser.unit_id;
            }
            let data = {
                sub_level_type: this.user_level + 1,
                id: this.user_level_id
            }
            UserService.getSubLevels('get-sub-levels', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.loading = false;
                        this.responseData = response.data.data;
                        this.sub_levels = response.data.data.list;
                        this.sub_level = response.data.data.sub_level;
                        this.permissions = response.data.data.permission;
                        this.$root.updateParent(response.data.data.page_title);
                        this.unit = response.data.data.unit;
                        this.loadRoleContextAndMerge();
                    } else {
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                    if (this.message == 'Unauthenticated.') {
                        location.replace('/');
                    }
                }
            );
        },
        clickSublevel(sub_level_id) {
            this.$router.push('/level-2-org/' + (this.user_level + 1) + '/' + sub_level_id);
        },
        nerpathamTarget(sub_level = null) {
            this.nerpatham_target = sub_level.nerpatham_target;
            this.sub_level_id = sub_level.id;
            $('#nerpathamTargetModel').modal('show');
        },
        addNerpathamTarget(data) {
            data.level = this.currentUser.user_level + 1;
            data.level_id = parseInt(this.sub_level_id);
            UserService.addAdmin('set-nerpatham-target', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.getSubLevels();
                        $('#nerpathamTargetModel').modal('hide')
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        }
    },
};
</script>
<style scoped>
.list-title {
    font-size: 16px;
    color: black;
}

.item {
    /* margin-bottom: 10px; */
}

.report-btn {
    width: 100% !important;
}

.add-member-btn {
    font-size: 16px !important;
    font-weight: 800 !important;
}

.wallet-footer-user {
    /* height: 46px !important; */
}

.text-only {
    font-size: 13px;
    font-weight: bold;
    color: black;
    /* margin-right: 5px; */
}


.chip-media {
    margin-left: 5px;
    width: 145px !important;
    padding-left: 25px !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.chip-icon {
    width: 50px !important;
}

.chip-label {
    padding: 0px 30px 0px 30px !important;
    font-size: 14px !important;
}

.bg-pink {
    background-color: #E6A6C7 !important;
}

.bg-pink-dark {
    background-color: #B85887 !important;
}


.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.menu-icon {
    font-size: 32px !important;
}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.back-color-primary {
    background: #1a418c !important;
}

.back-color-secondary {
    background: #666d79 !important;
}

.back-color-danger {
    background: #de6f56 !important;
}

.back-color-warning {
    background: #b19547 !important;
}

.back-color-red {
    background: #d55454 !important;
}

.back-color-violet {
    background: #072F5F !important;
}

.back-color-blue1 {
    background: #1a418c !important;
}

.back-color-blue2 {
    background: #1a418c !important;
}

.back-color-blue3 {
    background: #1a418c !important;
}

.back-color-blue4 {
    background: #1a418c !important;
}

.back-color-blue5 {
    background: #1a418c !important;
}

.back-color-blue6 {
    background: #1a418c !important;
}

.w-50 {
    width: 50px !important;
}

.btn-sm {
    height: 41px;
    padding: 0px 6px;
    font-size: 15px;
    font-family: 'Poppins';
}


.transactions .item {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    padding: 5px 5px;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.price {
    font-size: 50px;
}

.qvp-kids-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: #eef2ff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1a418c;
    flex-shrink: 0;
}

.qvp-kids-icon ion-icon {
    font-size: 24px;
    color: #1a418c;
}

/* Add extra space at the bottom of the Org page */
.org-bottom-spacer {
    height: 10px;
    width: 100%;
}

@media (max-width: 600px) {
    .org-bottom-spacer {
        height: 10px;
    }
}

.modern-button ion-icon {
    font-size: 22px;
    color: #1a418c;
    margin-bottom: 2px;
    display: block;
    line-height: 1;
}

.button-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin: 0 auto;
    padding: 0 4px;
}

.modern-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 0 8px 0;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 0.2px;
    transition: all 0.2s cubic-bezier(.4,0,.2,1);
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    border: 1.5px solid #e0e4ea;
    cursor: pointer;
    min-height: 64px;
    background: #f4f7fb;
    position: relative;
    overflow: hidden;
    gap: 6px;
}

.modern-button ion-icon {
    font-size: 22px;
    color: #1a418c;
    margin-bottom: 2px;
    display: block;
    line-height: 1;
}

.button-text {
    color: #1a418c;
    text-align: center;
    line-height: 1.3;
    font-size: 13px;
    font-weight: 500;
    margin-top: 0px;
    z-index: 1;
    position: relative;
}

/* Button Color Variants */
.members-list-btn {
    background: linear-gradient(135deg, #4a90e2, #357abd);
}

.members-list-btn:hover {
    background: linear-gradient(135deg, #357abd, #2d6da3);
}

.members-directory-btn {
    background: linear-gradient(135deg, #5b9bd5, #4a90e2);
}

.members-directory-btn:hover {
    background: linear-gradient(135deg, #4a90e2, #357abd);
}

.unit-clusters-btn {
    background: linear-gradient(135deg, #e91e63, #c2185b);
}

.unit-clusters-btn:hover {
    background: linear-gradient(135deg, #c2185b, #ad1457);
}

.data-collection-btn {
    background: linear-gradient(135deg, #4db6ac, #26a69a);
}

.data-collection-btn:hover {
    background: linear-gradient(135deg, #26a69a, #00897b);
}

/* Responsive Design */
@media (max-width: 14008px) {
    .button-grid {
        grid-template-columns: 2fr 2fr;
        gap: 12px;
        padding: 0 8px;
    }

    .button-grid-container {
        padding: 16px 12px;
        margin: 12px 0;
    }

    .modern-button {
        padding: 14px 20px;
        font-size: 13px;
        min-height: 48px;
    }
}

@media (max-width: 480px) {
    .button-grid-container {
        padding: 12px 8px;
        border-radius: 8px;
    }

    .modern-button {
        padding: 12px 0px;
        font-size: 12px;
        min-height: 50px;
        border-radius: 8px;
    }
}

.icon-circle {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #e6eaff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
}

.icon-circle ion-icon {
    color: #244087;
    font-size: 26px;
}
.org-action-btn {
    display: flex;
    align-items: center;
    width: 100%;
    background: #f3f6fb;
    color: #2355b3 !important;
    padding: 12px 0;
    border: 1.5px solid #2355b3;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    text-decoration: none;
    box-shadow: none;
    cursor: pointer;
    letter-spacing: 0.5px;
    justify-content: center;
    gap: 10px;
}

.button-text {
    flex: 1;
    text-align: center;
}

.native-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.native-modal-content {
    background: #fff;
    width: 100%;
    max-width: 500px;
    border-radius: 16px 16px 0 0;
    height: 75vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.native-modal-header {
    position: relative;
    padding: 14px 44px 8px;
    border-bottom: 0;
    text-align: center;
    flex-shrink: 0;
}

.native-modal-header h5 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    color: #27173E;
}

.org-sheet-close {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 24px;
    color: #aaa;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 4px;
}

.native-modal-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
    padding: 4px 0 calc(24px + env(safe-area-inset-bottom));
}

.org-link-group-modal .org-group-sheet {
    padding: 0 0 4px;
}

.org-link-group-modal .org-group-btn-list {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
}

.org-link-group-modal .org-group-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    min-height: 50px;
    padding: 10px 4px;
    background: transparent;
    border: 0;
    border-bottom: 1px solid #f1f3f7;
    border-radius: 0;
    color: #27173E;
    text-decoration: none;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.1em;
    box-shadow: none;
    transition: background 0.15s ease;
}

.org-link-group-modal .org-group-btn:last-child {
    border-bottom: 0;
}

.org-link-group-modal .org-group-btn:active {
    background: rgba(0, 0, 0, 0.04);
}

.org-link-group-modal .org-group-btn-icon {
    width: 24px;
    height: 24px;
    border-radius: 0;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: -5px;
}

.org-link-group-modal .org-group-btn-icon ion-icon {
    font-size: 22px;
    color: #1a418c;
}

.org-link-group-modal .org-group-btn-text {
    flex: 1;
    text-align: left;
}

.org-link-group-modal .org-group-btn-arrow {
    font-size: 16px;
    color: #c2c8d2;
    flex-shrink: 0;
}

.org-link-sheet-enter-active,
.org-link-sheet-leave-active {
    transition: opacity 0.28s ease;
}

.org-link-sheet-enter-active .org-link-sheet-panel,
.org-link-sheet-leave-active .org-link-sheet-panel {
    transition: transform 0.32s cubic-bezier(0.32, 0.72, 0, 1);
}

.org-link-sheet-enter-from,
.org-link-sheet-leave-to {
    opacity: 0;
}

.org-link-sheet-enter-from .org-link-sheet-panel,
.org-link-sheet-leave-to .org-link-sheet-panel {
    transform: translateY(100%);
}

.org-link-sheet-panel {
    will-change: transform;
}

</style>